import { formatCount } from "@circle-react/helpers/localeHelpers";
import { CONTENT_REACTION_TYPES } from "@circle-react/types/ContentReaction";
import type { ContentReactionCounts } from "@circle-react/types/ContentReaction";
import { Link } from "@circleco/compass/components/Link";
import { SentimentGroup } from "@circleco/compass/components/SentimentGroup";

import { t } from "@/i18n-js/instance";
import { AnimatedCount } from "@/react/components/shared/AnimatedCount";

import { REACTION_PRESENTATION } from "./constants";

interface ReactionSummaryProps {
  className?: string;
  count: number;
  counts: ContentReactionCounts;
  "data-testid"?: string;
  initialCount?: number;
  onClick?: () => void;
}

export const ReactionSummary = ({
  className,
  count,
  counts,
  "data-testid": testId,
  initialCount,
  onClick,
}: ReactionSummaryProps) => {
  if (count === 0) return null;

  const label = t("reactions.count", {
    count,
    localeCount: formatCount(count),
  });

  return (
    <Link
      asButton
      variant="custom"
      typography="body-sm"
      color="secondary"
      hoverColor="primary"
      className={className}
      aria-label={label}
      data-testid={testId}
      onClick={onClick}
    >
      <span className="flex items-center gap-2">
        <SentimentGroup
          kinds={CONTENT_REACTION_TYPES.flatMap(reactionType =>
            counts[reactionType] > 0
              ? [REACTION_PRESENTATION[reactionType].sentiment]
              : [],
          )}
        />
        <AnimatedCount count={count} initialCount={initialCount} />
      </span>
    </Link>
  );
};
